import * as React from 'react';
import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { useLoginPage } from '@/features/auth/hooks/useLoginPage';

export function LoginPage() {
  const { forms, handleSubmit } = useLoginPage();
  const {
    register,
    formState: { errors },
  } = forms;

  return (
    <Form {...forms}>
      <form onSubmit={handleSubmit}>
        <div className="flex items-center justify-center min-h-screen bg-gray-100">
          <Card className="w-full max-w-md">
            <CardHeader>
              <CardTitle className="text-2xl font-bold text-center">ログイン</CardTitle>
              <CardDescription className="text-center">
                アカウントにログインしてください
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div className="space-y-4">
                <FormField
                  {...register('email')}
                  name="email"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>Email</FormLabel>
                      <FormControl>
                        <Input type="email" placeholder="your@email.com" {...field} />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
                <FormField
                  {...register('password')}
                  name="password"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>Password</FormLabel>
                      <FormControl>
                        <Input type="password" placeholder="password" {...field} />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
              </div>
            </CardContent>
            <CardFooter>
              <div className="w-full flex flex-col space-y-2">
                <Button type="submit" className="w-full">
                  ログイン
                </Button>
                {errors.root && <FormMessage>{errors.root.message}</FormMessage>}
              </div>
            </CardFooter>
          </Card>
        </div>
      </form>
    </Form>
  );
}
